import { render, staticRenderFns } from "./NlpFaq.vue?vue&type=template&id=71808b78&scoped=true"
import script from "./NlpFaq.vue?vue&type=script&lang=js"
export * from "./NlpFaq.vue?vue&type=script&lang=js"
import style0 from "./NlpFaq.vue?vue&type=style&index=0&id=71808b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71808b78",
  null
  
)

export default component.exports